/* eslint-disable */
import sanitizeHtml from "sanitize-html";

export default {
  // Vue 3 directive API (bind/inserted/update are ignored — v-cb-html never ran)
  mounted(el, binding, vnode) {
    if (!binding) return;
    sanitizeHtmlHandler(el, vnode, binding);
  },
  updated(el, binding, vnode) {
    if (
      el.tagName == "TEXTAREA" ||
      el.contentEditable == "true" ||
      !binding
    ) {
      return;
    }
    sanitizeHtmlHandler(el, vnode, binding);
  },
};

function sanitizeHtmlHandler(el, vnode, binding) {
  let value =
    typeof binding.value === "object" && binding.value !== null
      ? binding.value.text || ""
      : binding.value || "";
  let allowedTags = binding.value.tags || ["b", "i", "em", "strong", "a", "u", "s"];
  let allowedAttrs = binding.value.attrs || {
    a: ["href", "target"]
  };
  let sanitizedContent = sanitizeHtml(value, {
    allowedTags: allowedTags,
    allowedAttributes: allowedAttrs
  });
  el.innerHTML = sanitizedContent;
}
